// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4490) return "static/chunks/4490-064c60abd1bf8bac.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7330 ? "d3ac728e" : chunkId) + "." + {"661":"b1263fe48777783c","1639":"ea7c8b65a3f66bd4","1646":"314724838722bc18","1873":"cc254927ea553d4c","5139":"3af505ae0c727fe9","7330":"7c5c7cdb44c87945","8336":"199a1c519a1030e5","8514":"a8ad0e50c6f777bb"}[chunkId] + ".js";
};